/* RESPONSIBLE TEAM: team-app-security */
import ApplicationAdapter from './application';

/*
 * Security fix: Send email in POST body instead of URL query parameters to avoid PII exposure.
 * See: https://github.com/intercom/intercom/issues/459360
 */
export default ApplicationAdapter.extend({
  query(store, type, query) {
    let url = this.buildURL(type.modelName, null, null, 'query', query);
    return this.ajax(url, 'POST', { data: query });
  },
});
